export var ESFeatureTypes;
(function (ESFeatureTypes) {
    ESFeatureTypes["Emoji"] = "emoji";
    ESFeatureTypes["Comment"] = "comment";
    ESFeatureTypes["ExternalData"] = "external.data";
    ESFeatureTypes["Question"] = "question";
})(ESFeatureTypes || (ESFeatureTypes = {}));
